var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"flex items-center"},_vm._l((_vm.navMenuItems),function(item,i){return _c('router-link',{staticClass:"text-white p-4",attrs:{"to":item.url}},[_c('small',[_c('strong',{staticClass:"hover:m-2"},[_vm._v(_vm._s(item.name))])])])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }